import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstadoRevisionCargosGestionAcademicaDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstadoRevisionCargosGestionAcademicaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEstadoRevisionCargosGestionAcademicaService(): Observable<BodyListResponse<EstadoRevisionCargosGestionAcademicaDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionCargosGestionAcademicaDTO>>(API_URL + '/api/v1/estadoRevisionCargosGestionAcademica/todos');
  }

  guardarEstadoRevisionCargosGestionAcademicaService(estadoRevisionCargosGestionAcademicaDTO: EstadoRevisionCargosGestionAcademicaDTO): Observable<EstadoRevisionCargosGestionAcademicaDTO> {
    return this.http.post<EstadoRevisionCargosGestionAcademicaDTO>(API_URL + '/api/v1/estadoRevisionCargosGestionAcademica', estadoRevisionCargosGestionAcademicaDTO);
  }

  getEstadoRevisionCargosGestionAcademicaPorCodigoEstadoRevisionCargosGestionAcademicaService(codigoEstadoRevisionCargosGestionAcademica: string): Observable<BodyResponse<EstadoRevisionCargosGestionAcademicaDTO>> {
    return this.http.get<BodyResponse<EstadoRevisionCargosGestionAcademicaDTO>>(API_URL + '/api/v1/estadoRevisionCargosGestionAcademica/' + codigoEstadoRevisionCargosGestionAcademica);
  }

  getEstadoRevisionCargosGestionAcademicaPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EstadoRevisionCargosGestionAcademicaDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionCargosGestionAcademicaDTO>>(API_URL + '/api/v1/estadoRevisionCargosGestionAcademica/persona/' + codigoPersona);
  }

}
